import axios from "axios"

import * as actions from "../actions/lookupCodeType"

  
export function getLookupCodeTypes() {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.get(process.env.REACT_APP_API_HOST + "/api/lookupcodeType/getLookupCodeTypes")
        .then(response => {
          //dispatch(actions.getCandidate(response.data.SuccessOutput))
          let lookupCodeTypes = response && response.data ? response.data.$values : []
          dispatch(actions.getLookupCodeTypes(lookupCodeTypes))
          resolve(response)
        })
        .catch(error => reject(error))
    })
  }
}


// WEBPACK FOOTER //
// ./src/actionCreators/lookupCodeType.js